import { List, Map as ImmMap } from 'immutable';
import {
	DESTROY_APP_STATUSES,
	RECEIVE_STATUS,
	RECEIVE_NEXT_PROVIDER_ID,
	RECEIVE_NEXT_PROVIDER_NAME,
	RECEIVE_NEXT_PROVIDER_AUTOSUBMIT,
	SET_COMPLETED_APP_STATUS_FIELDS,
} from './constants';

export const initialState = new ImmMap({
	appStatuses: new List(),
});

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case DESTROY_APP_STATUSES: {
			return state
				.set('appStatuses', new List())
				.set('nextProviderId', null)
				.set('nextProviderName', null)
				.set('nextProviderAutoSubmit', false);
		}
		case RECEIVE_STATUS: {
			return state.mergeIn(['appStatuses'], action.applicationStatuses);
		}
		case RECEIVE_NEXT_PROVIDER_ID: {
			return state.set('nextProviderId', action.nextProviderId);
		}
		case RECEIVE_NEXT_PROVIDER_NAME: {
			return state.set('nextProviderName', action.nextProviderName);
		}
		case RECEIVE_NEXT_PROVIDER_AUTOSUBMIT: {
			return state.set('nextProviderAutoSubmit', action.nextProviderAutoSubmit);
		}
		case SET_COMPLETED_APP_STATUS_FIELDS: {
			return state
				.set('completedAppStatusTitle', action.completedAppStatusTitle)
				.set('completedAppStatusText', action.completedAppStatusText);
		}
		default:
			return state;
	}
};

export default reducer;
